export default __webpack_public_path__ + "static/media/Large-Cap-Fund-passcode-banner.e8999494.jpg";